interface MakeAddTaskQueueParams {
    type: string,
    taskList: Array<FreeObjMap>
}

function makeAddTaskQueue(params: MakeAddTaskQueueParams): Array<AddTask> {
    let result: Array<AddTask> = [];

    params.taskList.forEach((task: FreeObjMap): void => {
        let type: any = params.type;

        result.push({
            cubeData: task,
            type: params.type === 'shelves' ? 'shelf': type,
            extendParams: {
                addType: 'normal'
            }
        });
    });

    return result;
}

export {
    makeAddTaskQueue
};
